import type { CommunityTheme } from '@/../storyblok/types/overrides/ContentTypeCommunityStoryblok.ts'

// This function sets global CSS variables for theme colors
// These can then be used as Tailwind colours with opacity support, eg
// bg-community-dark
// border-community-light
// text-community-content-dark/50
// community-content-light

export function setThemeGlobalCssVariables(
  backgroundDark?: CommunityTheme,
  backgroundLight?: CommunityTheme,
  contentDark?: CommunityTheme,
  contentLight?: CommunityTheme,
) {
  try {
    toRgbCssVariable(
      backgroundDark?.color || '#00843D',
      '--community-background-dark',
    )
    toRgbCssVariable(
      backgroundLight?.color || '#ffffff',
      '--community-background-light',
    )
    toRgbCssVariable(
      contentDark?.color || '#ffffff',
      '--community-content-dark',
    )
    toRgbCssVariable(
      contentLight?.color || '#242422',
      '--community-content-light',
    )
  } catch (error) {
    console.error('Error converting hex color to RGB:', error)
  }
}

// Convert hex color to RGB format and sets it as a CSS variable
function toRgbCssVariable(color: string, cssVarName: string) {
  if (!color) return

  const root = document.documentElement

  const hex = color.replace('#', '')

  // Validate hex color code
  if (!/^([0-9A-Fa-f]{3}){1,2}$/.test(hex)) {
    throw new Error('Invalid hex color code')
  }

  // Expand shorthand hex to full form
  const fullHex =
    hex.length === 3
      ? hex
          .split('')
          .map((char) => char + char)
          .join('')
      : hex

  // Extract RGB values
  const [r, g, b] = [0, 2, 4].map((offset) =>
    parseInt(fullHex.substring(offset, offset + 2), 16),
  )

  //  set CSS variable
  root.style.setProperty(cssVarName, `${r} ${g} ${b}`)
}
